export default __webpack_public_path__ + "media/zurb/img/development-process/hulu-5f0d8a52e027d7bb1add7138bd2554ad.png";